import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IServerStatusQuery, IServerStatus, ISelectItem, IAppStatus, IExecutiveSitrepReport } from '../models/index';

import { Observable } from 'rxjs/RX';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { AuthenticationService } from './authentication.service';
import { environment } from '../../../environments/environment';
import { IReport, ReportExportType } from '../models/reports';

@Injectable()
export class AnalyticsService {

    constructor(
        private http: HttpClient,
        private authService: AuthenticationService) { }

    private apiUrl = environment.api_url;
    private getHttpOptions() {
        return this.authService.getAuthHttpOptions();
    }

    getAppStatuses(): Observable<IAppStatus[]> {
        return this.http.get<IAppStatus[]>(this.apiUrl + 'AppStatuses', this.getHttpOptions());
    }

    getAppStatusesForServer(wowzaId: number): Observable<IAppStatus[]> {
        return this.http.get<IAppStatus[]>(this.apiUrl + 'AppStatuses/Get/' + wowzaId, this.getHttpOptions());
    }

    getAppStatusHistory(query: IServerStatusQuery): Observable<any> {
        return this.http.post<IServerStatus[]>(this.apiUrl + 'AppStatuses/GetHistory', query, this.getHttpOptions());
    }

    getAppNames(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'DropDowns/GetAppNames', this.getHttpOptions());
    }

    getExecutiveSitRepReport(): Observable<IExecutiveSitrepReport[]> {
        return this.http.get<IExecutiveSitrepReport[]>(this.apiUrl + 'ExecutiveSitRep/GetExecutiveSitRepReport', this.getHttpOptions());
    }

    getServerStatuses(): Observable<IServerStatus[]> {
        return this.http.get<IServerStatus[]>(this.apiUrl + 'ServerStatuses', this.getHttpOptions());
    }

    getServerStatusHistory(query: IServerStatusQuery): Observable<any> {
        return this.http.post<IServerStatus[]>(this.apiUrl + 'ServerStatuses/GetHistory', query, this.getHttpOptions());
    }

    getStatisticsInterval(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'DropDowns/GetStatisticsIntervals', this.getHttpOptions());
    }

    getRecentWowzaVideoSessions()  {
        return this.http.get(this.apiUrl + 'WowzaVideoHistory/GetRecentWowzaVideoHistory', this.getHttpOptions());
    }

    getWowzaVideoSessions(queryString: string)  {
        return this.http.get(this.apiUrl + 'WowzaVideoHistory/GetWowzaVideoHistory' + queryString, this.getHttpOptions());
    }

    getWowzaServers(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'DropDowns/GetWowzaServers', this.getHttpOptions());
    }

    // special call for export
    exportReport(report: IReport): Observable<any> {
        const options: any = {
            headers: this.getHttpOptions().headers,
            observe: 'body',
            responseType: 'arraybuffer'
        };

        var url = 'Reports';
        switch(report.value) {
            case 'ExecutiveSitRepReport':
                url = 'ExecutiveSitRep';
                break;
            case 'VideoSessionHistory':
                url = 'WowzaVideoHistory';
                break;
        }
        return this.http.post<any>(`${this.apiUrl}${url}/ExportReport`, report, options);
    }
}
